const normaliseLatLong = (value: string) => value.replace(/[^\d-.]/gi, "") || "";

export {
  normaliseLatLong
};

const normaliseWholeNumber = (value: string) => value.replace(/[^\d]/gi, "") || "";

export {
  normaliseWholeNumber
};
